import * as React from 'react'

import Alert from '@mui/material/Alert'

interface Props {
  /** What the note is about, e.g. "the referral". */
  subject: string
}

/**
 * Info note for a missing field this modal cannot edit, pointing the user to the full Review flow.
 */
export function UseReviewNote(props: Props) {
  const { subject } = props

  return (
    <Alert severity="info" data-test-id="auto-review-use-review-note">
      Use Review to set {subject}.
    </Alert>
  )
}
UseReviewNote.displayName = 'UseReviewNote'
